import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Pagination, Spin, Table, Select } from "antd";

import { handleError } from "../../modules/presence/sagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 10;
const { Option } = Select;

const Filter = ({ item, selectedItem, fetchDistinct, onChange, placeholder, token, width }) => {
  const [items, setItems] = useState([]);

  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(item, token);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(client => (
        <Option key={client} value={client}>
          {client}
        </Option>
      ))}
    </Select>
  );
};

const ByTerryOrders = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [selectedOrderNb, setSelectedOrderNb] = useState();
  const [selectedMailNumber, setSelectedMailNumber] = useState();

  const match = { number: selectedOrderNb, mail_number: selectedMailNumber };
  const fetchOrders = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/sidely/orders`,
        {
          match,
          page,
          pageSize: PAGE_SIZE,
          sort: { Dateve: -1 }
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data.docs);

      setTotal(result.data.total);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchOrders();
  }, [page, selectedOrderNb, selectedMailNumber]);
  const columns = [
    {
      title: "uuid de la visite",
      dataIndex: "form_uuid",
      key: "form_uuid",
      render: form_uuid => {
        return <span>{form_uuid}</span>;
      }
    },
    {
      title: "lien cliquable vers la visite",
      dataIndex: "form_url",
      key: "form_uuid",
      render: (form_uuid, item) => {
        const url = `https://app.sidely.app/form-instance-list?id=${item.form_id}&instance=${item.form_uuid}#list`;
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            Lien vers la visite
          </a>
        );
      }
    },
    {
      title: "statut de la commande",
      dataIndex: "status",
      key: "status",
      render: status => {
        return <span>{status}</span>;
      }
    },

    {
      title: "numéro",
      dataIndex: "number",
      key: "number",
      render: number => {
        return <span>{number}</span>;
      }
    },
    {
      title: "date de la commande",
      dataIndex: "Dateve",
      key: "Dateve",
      render: Dateve => {
        return <span>{Dateve}</span>;
      }
    },
    {
      title: "numéro du mail de commande",
      dataIndex: "mail_number",
      key: "mail_number",
      render: mail_number => {
        return <span>{mail_number}</span>;
      }
    },
    {
      title: "id formulaire",
      dataIndex: "form_id",
      key: "form_id",
      render: form_id => {
        return <span>{form_id}</span>;
      }
    }
  ];

  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Liste des commandes By Terry`}</div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Filter
            selectedItem={selectedOrderNb}
            fetchDistinct={fetchDistinct}
            item={"number"}
            placeholder={"number"}
            onChange={setSelectedOrderNb}
            token={token}
            width={400}
          />
          <Filter
            selectedItem={selectedMailNumber}
            fetchDistinct={fetchDistinct}
            item={"mail_number"}
            placeholder={"mail_number"}
            onChange={setSelectedMailNumber}
            token={token}
            width={400}
          />
        </div>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
        <Pagination defaultCurrent={1} total={total} onChange={setPage} />
      </React.Fragment>
    </Container>
  );
};

export default ByTerryOrders;

const fetchDistinct = async (item, token) => {
  return axios
    .post(
      `${baseapi}/sidely/orders/distincts/${item}`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/pages/sidely/ByTerryOrders.js